import AuthService from "../services/AuthService";
import UserModel from "../models/UserModel";
import { RequiredParamException } from "../exceptions/InvalidParamException";
import UserService from "api/services/UserService";

class AuthController {
  createUserAccount(
    name: string,
    email: string,
    password: string
  ): Promise<UserModel | null> {
    if (!name) throw new RequiredParamException("name");
    if (!email) throw new RequiredParamException("email");
    if (!password) throw new RequiredParamException("password");

    return AuthService.createUserAccount(name, email, password);
  }

  async signInWithEmail(email: string, password: string): Promise<boolean> {
    if (!email) throw new RequiredParamException("email");
    if (!password) throw new RequiredParamException("password");

    return AuthService.signInWithEmail(email, password);
  }

  sendPasswordResetEmail(email: string): Promise<void> {
    if (!email) throw new RequiredParamException("email");
    return AuthService.sendPasswordResetEmail(email);
  }

  async getAuthenticatedUserData(): Promise<UserModel | undefined> {
    const auth = AuthService.currentUser;
    if (auth) {
      const user = await UserService.getUserByUid(auth.uid);
      if (user) {
        const isValid = await AuthService.validateUser(user);
        if (isValid) return user;
      }
    }
    return undefined;
  }
}

export default new AuthController();
